import { render, staticRenderFns } from "./mys.vue?vue&type=template&id=07f85e77&scoped=true&"
import script from "./mys.vue?vue&type=script&lang=js&"
export * from "./mys.vue?vue&type=script&lang=js&"
import style0 from "./mys.vue?vue&type=style&index=0&id=07f85e77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f85e77",
  null
  
)

export default component.exports